import React from 'react';
import PropTypes from 'prop-types';
import ESIInclude from '@JohnLewisPartnership/jl-esi-components';

import { useRouter } from 'next/router';
import classnames from 'classnames';
import styles from './Breadcrumbs.module.scss';

export const getNvalFromUrl = (url) => {
  if (!url) return null;
  const lastSlash = url.lastIndexOf('/');
  return url.slice(lastSlash + 1);
};

export const EsiBreadcrumbs = ({ query, lastBreadcrumb }) => {
  const {
    type: routerPageType,
    'search-term': term,
    facetId,
    listHead,
  } = query;
  const { item, url } = lastBreadcrumb;
  let esiSource;

  switch (routerPageType) {
    case 'brand': {
      esiSource = `/esi/breadcrumbs/brand/${encodeURIComponent(item)}`;
      break;
    }

    case 'browse': {
      const nVal = getNvalFromUrl(url);
      esiSource =
        nVal && nVal.startsWith('c')
          ? `/esi/breadcrumbs/category/${nVal.substring(1)}`
          : `/esi/breadcrumbs/browse/${nVal}`;
      break;
    }

    case 's': {
      const searchTerm =
        facetId && facetId.length > 0 ? facetId[0].replace(/-/g, ' ') : '';
      esiSource = `/esi/breadcrumbs/search/${encodeURIComponent(searchTerm)}`;
      break;
    }

    default:
      esiSource = listHead
        ? `/esi/breadcrumbs/search/${encodeURIComponent(listHead)}`
        : `/esi/breadcrumbs/search/${encodeURIComponent(term)}`;
  }

  return (
    <div className={classnames(styles['breadcrumbs-carousel'])}>
      <ESIInclude src={esiSource} id="esiBreadcrumbs" />
    </div>
  );
};

export const Breadcrumbs = ({ breadcrumbs }) => {
  const { query } = useRouter();

  if (breadcrumbs?.length === 0) {
    return null;
  }

  const [lastBreadcrumb] = breadcrumbs.slice(-1);

  return <EsiBreadcrumbs query={query} lastBreadcrumb={lastBreadcrumb} />;
};

Breadcrumbs.defaultProps = {
  breadcrumbs: [],
};

Breadcrumbs.propTypes = {
  breadcrumbs: PropTypes.arrayOf(
    PropTypes.shape({
      clickable: PropTypes.string,
      displayName: PropTypes.string,
      type: PropTypes.string,
      url: PropTypes.string,
      item: PropTypes.string,
    })
  ),
};
